import axiosInstance from '@/utils/axios';
import { handleApiError } from '@/utils/helpers';

// @ List all permission entries
export const permissionsList = async () => {
  let response = {};
  try {
    response = await axiosInstance.post(`/v3/admin_permission_list`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ List all game client download entries
export const downloadList = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.get(`/download_versions`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Show game client download entry
export const downloadGet = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.get(`/admin/download_versions/${payload.id}`);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Update game client download entry
export const downloadUpdate = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.put(`/admin/download_versions`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};

// @ Create game client download entry
export const downloadCreate = async (payload) => {
  let response = {};
  try {
    response = await axiosInstance.post(`/admin/download_versions`, payload);
    return response;
  } catch (error) {
    return handleApiError(error);
  }
};
